module.exports = __webpack_public_path__ + "static/media/gl.48bf3e4e.svg";